__turbopack_context__.v({
  "fadeInItems": "ImageVideoBlock-module__Eewrmq__fadeInItems",
  "mediaPortrait": "ImageVideoBlock-module__Eewrmq__mediaPortrait",
  "spacing--lg": "ImageVideoBlock-module__Eewrmq__spacing--lg",
  "spacing--md": "ImageVideoBlock-module__Eewrmq__spacing--md",
  "spacing--sm": "ImageVideoBlock-module__Eewrmq__spacing--sm",
  "spacing--xl": "ImageVideoBlock-module__Eewrmq__spacing--xl",
  "spacing--xs": "ImageVideoBlock-module__Eewrmq__spacing--xs",
  "spacing--xxl": "ImageVideoBlock-module__Eewrmq__spacing--xxl",
  "spacing--xxs": "ImageVideoBlock-module__Eewrmq__spacing--xxs",
  "spacing--xxxl": "ImageVideoBlock-module__Eewrmq__spacing--xxxl",
  "spacing--xxxs": "ImageVideoBlock-module__Eewrmq__spacing--xxxs",
});
